import { useQuery } from 'react-query';

import { getRoleOptions } from '../api/getRoleOptions';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch company role options (already parsed via parseRoleOptions schema).
 *
 * @param {Object} [params]
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 * @param {(error: unknown) => void} [options.onError]
 */
export const useRoleOptions = (params, { enabled = true, onError } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.roleOptions(params),
    ({ signal }) => getRoleOptions(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
      onError,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useRoleOptions;
